interface IAnalyzedData {
  fileName: string
  fileFullName: string
  fileSuffix: string
  type: string
  size: number // kb
  duration?: number // s
  width: number
  height: number
}

export default function(file: File, el: HTMLVideoElement | HTMLImageElement): IAnalyzedData {
  if (el.tagName === 'VIDEO') {
    const video = el as HTMLVideoElement
    return analyzeVideo(file, video)
  }
  const image = el as HTMLImageElement
  return analyzeImage(file, image)
}

function analyzeVideo(file: File, video: HTMLVideoElement) {
  const fileFullName = file.name
  const fileName = file.name.slice(0, file.name.lastIndexOf('.'))
  const fileSuffix = file.name.slice(file.name.lastIndexOf('.') + 1, file.name.length)
  const size = file.size / 1024
  const type = file.type

  // video meta data must be loaded
  const duration = video.duration
  const width = video.videoWidth
  const height = video.videoHeight

  if (!duration || duration === Infinity) {
    throw new Error('Invalid Video Duration')
  }
  if (!width || !height) {
    throw new Error('Invalid Video Width or Height')
  }

  return { fileName, fileFullName, fileSuffix, type, size, duration, width, height }
}

function analyzeImage(file: File, image: HTMLImageElement) {
  const fileFullName = file.name
  const fileName = file.name.slice(0, file.name.lastIndexOf('.'))
  const fileSuffix = file.name.slice(file.name.lastIndexOf('.') + 1, file.name.length)
  const size = file.size / 1024
  const type = file.type

  const width = image.naturalWidth
  const height = image.naturalHeight

  if (!width || !height) {
    throw new Error('Invalid Image Width or Height')
  }

  return { fileName, fileFullName, fileSuffix, type, size, width, height }
}
